import React, { ComponentProps, FC } from "react";
import { type ViewProps } from "react-native";

import { TextClassContext } from "@/context/TextClassContext";
import { cn } from "@/utils/tailwind";

import { VnBox } from "./VnBox";
import { VnText } from "./VnText/VnText";

type VnCardPropsType = ViewProps;

export const VnCard: FC<VnCardPropsType> = ({ className, ...props }) => {
  return (
    <TextClassContext.Provider value="text-card-foreground">
      <VnBox
        className={cn(
          "border-border bg-card shadow-base flex flex-col gap-6 rounded-xl border p-5",
          className,
        )}
        {...props}
      />
    </TextClassContext.Provider>
  );
};

type VnCardHeaderPropsType = ViewProps;

export const VnCardHeader: FC<VnCardHeaderPropsType> = ({
  className,
  ...props
}) => {
  return (
    <VnBox className={cn("flex flex-col gap-1.5 px-6", className)} {...props} />
  );
};

type VnCardTitlePropsType = ComponentProps<typeof VnText>;

export const VnCardTitle: FC<VnCardTitlePropsType> = ({
  className,
  variant = "headerOne",
  ...props
}) => {
  return (
    <VnText
      role="heading"
      aria-level={3}
      variant={variant}
      className={cn("leading-tight", className)}
      {...props}
    />
  );
};

type VnCardDescriptionPropsType = ComponentProps<typeof VnText>;

export const VnCardDescription: FC<VnCardDescriptionPropsType> = ({
  className,
  variant = "md",
  ...props
}) => {
  return (
    <VnText
      variant={variant}
      className={cn("text-muted-foreground", className)}
      {...props}
    />
  );
};

type VnCardContentPropsType = ViewProps;

export const VnCardContent: FC<VnCardContentPropsType> = ({
  className,
  ...props
}) => {
  return <VnBox className={cn("px-6", className)} {...props} />;
};

type VnCardFooterPropsType = ViewProps;

export const VnCardFooter: FC<VnCardFooterPropsType> = ({
  className,
  ...props
}) => {
  return (
    <VnBox
      className={cn("flex flex-row items-center px-6", className)}
      {...props}
    />
  );
};
